import {
  Configuration,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser'

import { getEnvVar, getEnvVarWithDefault } from './env'

const postLogoutRedirectUri =
  getEnvVar('REACT_APP_ENVIRONMENT') !== 'prod'
    ? `https://plr-${getEnvVar('REACT_APP_ENVIRONMENT')}.lennar.com/logout`
    : 'https://plr.lennar.com/logout'

export const msalConfig: Configuration = {
  auth: {
    authority: `https://login.microsoftonline.com/${getEnvVar(
      'REACT_APP_MSAL_TENANT_ID'
    )}/`,
    clientId: getEnvVarWithDefault('REACT_APP_MSAL_CLIENT_ID', ''),
    navigateToLoginRequestUrl: true,
    postLogoutRedirectUri,
    redirectUri: '/',
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (
        level: LogLevel,
        _message: string,
        containsPii: boolean
      ) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            break
          case LogLevel.Info:
            break
          case LogLevel.Verbose:
            break
          case LogLevel.Warning:
            break
          default:
            break
        }
      },
    },
  },
}

/**
 * Lives here rather than in src/index.tsx so that library code needing a token
 * imports the MSAL client, not the application entry point. The entry point also
 * calls ReactDOM.render, sets the MUI licence and initialises FullStory, so a
 * test that reached axiosInstance would otherwise boot the whole app.
 */
export const msalInstance = new PublicClientApplication(msalConfig)

export const loginRequest: {
  scopes: string[]
} = {
  scopes: [],
}
